<template>
  <v-dialog v-model="show" persistent max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on"><v-icon>mdi-plus</v-icon></v-btn>
    </template>

    <v-card>
      <v-card-title class="mb-4">
        <span class="text-h5">Новий Менеджер</span>
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="inputs.login"
          label="Логін"
          outlined
          dense
          hide-details
          class="mb-4"
        ></v-text-field>

        <v-text-field
          v-model="inputs.password"
          label="Пароль"
          outlined
          dense
          hide-details
          class="mb-4"
        ></v-text-field>

        <v-text-field
          v-model="inputs.firstName"
          label="Ім'я"
          outlined
          dense
          hide-details
          class="mb-4"
        ></v-text-field>

        <v-text-field
          v-model="inputs.lastName"
          label="Прізвище"
          outlined
          dense
          hide-details
          class="mb-4"
        ></v-text-field>

        <v-text-field
          v-model="inputs.nickname"
          label="Нікнейм"
          outlined
          dense
          hide-details
          class="mb-4"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">Закрити</v-btn>
        <v-btn color="blue darken-1" :loading="loading" text @click="save"
          >Зберегти</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createSupport } from '@/api/admin/supports';

export default {
  name: 'SupportsCreateDialog',

  data() {
    return {
      loading: false,
      show: false,

      inputs: {
        login: '',
        password: '',
        firstName: '',
        lastName: '',
        nickname: '',
      },
    };
  },

  methods: {
    save() {
      if (this.loading) return;
      this.loading = true;

      createSupport(this.inputs)
        .then(res => {
          this.close();
          this.$emit('create', res.data);
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.inputs = {
        login: '',
        password: '',
        firstName: '',
        lastName: '',
        nickname: '',
      };
      this.show = false;
    },
  },
};
</script>

<style scoped></style>
